import { useMutation, useQuery } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';
import type {
  PreviewAPInvoiceExceptionsInput,
  SuggestExceptionTestInvoicesInput,
} from '@erp/rpc';

/**
 * Dry-run a rule set (saved and/or draft guidance) against invoices.
 * Nothing is persisted, so no query invalidation.
 */
export function usePreviewAPInvoiceExceptions() {
  return useMutation({
    mutationFn: (input: PreviewAPInvoiceExceptionsInput) =>
      rpcClient.accountsPayable.invoices.previewExceptions(input),
  });
}

/** Curated unmatched-open + matched-control invoices for the test bench. */
export function useSuggestExceptionTestInvoices(
  input: SuggestExceptionTestInvoicesInput = {},
  options?: { enabled?: boolean },
) {
  return useQuery({
    ...orpc.accountsPayable.invoices.suggestExceptionTestInvoices.queryOptions({
      input,
    }),
    enabled: options?.enabled ?? true,
    staleTime: 60_000,
  });
}
